import React from "react";
import { Link } from "react-router-dom";
import GeoPhone from "../../components/GeoData";
export default function ContactMap() {
    return (
        <>
            <section className="contact-detail">
                <div className="container">
                    <div className="edit-line row">
                        <div className="col-lg-12 col-md-12 col-12">
                            <div className="border-space"></div>
                        </div>
                        <div className="col-lg-3 col-md-6 col-12 ">
                            <div className="formdetail-box">
                                <span className="fontdeatail-head heading"> Call Us:</span>
                                <ul>

                                    <li>
                                        {/* <Link className="formdetail-text" to="tel:+911244807600"> +91 124 4807600 </Link> */}
                                        <span className="country-name"><GeoPhone variant="countryname" /> :</span>  <GeoPhone variant="footer" />
                                    </li>
                                    {/* <li><Link className="formdetail-text" to="tel:+971563570000">+971 56 357 0000</Link></li> */}
                                </ul>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 col-12">
                            <div className="formdetail-box">
                                <span className="fontdeatail-head heading">Mail Us:</span>
                                <ul>
                                    <li><Link className="formdetail-text" to="mailto:sales@supershinelaundry.ae">sales@supershinelaundry.ae</Link></li>
                                    <li><Link className="formdetail-text" to="mailto:info@supershine.com">info@supershine.in</Link></li>
                                    <li><Link className="formdetail-text" to="mailto:contact@supershinelaundry.ae">contact@supershinelaundry.ae</Link></li>


                                </ul>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 col-12">
                            <div className="formdetail-box">
                                <span className="fontdeatail-head heading">Corporate Office:</span>
                                <ul>
                                    <li> <p> Vipul Square, 205, 2nd Floor, B Block, Sushant Lok Phase I,  Gurgaon, Haryana, India</p>  </li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 col-12">
                            <div className="formdetail-box">
                                <span className="fontdeatail-head heading">Global Office:</span>
                                <ul>
                                    {/* <li> <p>Trading LLC Plot No. 518-0, Office <br/> No. 7 Al Garhoud, Dubai, UAE.</p></li> */}
                                    <li>Mumbai, Bangalore, Chennai, Hyderabad, Kolkata, Dubai, Tanzania (Africa)</li>
                                    <li className="margin-top">Supershine Laundry Equipment Trading LLC Plot No – 518-0, Office No – 7 Al Garhoud, Dubai, UAE</li>

                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* <section className="originalmap-area">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12 col-md-12 col-12">
                            <div className="map-mainbox">
                                <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3507.631675840813!2d77.07824327408656!3d28.46051749187382!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390d19a8c2f606b5%3A0x7ef797022788ed9a!2sSUPERSHINE%20LAUNDRY%20SYSTEMS%20PVT.%20LTD.!5e0!3m2!1sen!2sin!4v1770717126094!5m2!1sen!2sin" className="gmap-edit" />
                            </div>
                        </div>
                    </div>
                </div>
            </section> */}
        </>
    )
}